<template>
  <div>
    <Hero class="view-hero" />
    <slot />
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
}
</script>
